import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@printtat/ui";
import { MoreVertical, LogOut } from "lucide-react";

export const UserMenu = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [imageError, setImageError] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/sign-in");
  };

  if (!user) {
    return null;
  }

  const getInitials = () => {
    const firstName = user.firstName || "";
    const lastName = user.lastName || "";
    if (firstName || lastName) {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
    }
    return user.email.charAt(0).toUpperCase();
  };

  const hasPicture = !!user.profilePicture;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center space-x-2 w-full p-2 pr-4 rounded-xl hover:bg-gray-100 transition-colors">
          <div className="w-6 h-6 rounded-full overflow-hidden bg-indigo-600 flex items-center justify-center text-white text-sm font-medium">
            {hasPicture && !imageError ? (
              <img
                src={user.profilePicture!.startsWith('http')
                  ? user.profilePicture
                  : `${import.meta.env.VITE_API_URL || 'http://localhost:4000'}${user.profilePicture}`
                }
                alt={`${user.firstName} ${user.lastName}`}
                className="w-full h-full object-cover"
                onError={() => setImageError(true)}
              />
            ) : (
              getInitials()
            )}
          </div>
          <div className="flex-1 text-left">
            <div className="text-xs font-medium text-gray-900 leading-none">
              {user.firstName || user.email}
            </div>
            <div className="text-xs text-gray-500">{user.email}</div>
          </div>
          <MoreVertical className="w-4 h-4 text-gray-400 group-hover:text-gray-500 transition-colors" />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent className="w-44" side="top" align="center" sideOffset={6}>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={handleLogout}
          className="text-red-600 py-1.5 px-2.5 text-sm"
        >
          <LogOut className="mr-2 h-3.5 w-3.5" />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
